parasails.registerPage('enjoy', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    initialPage: 0,
    eventID: '',
    eventIsLive: true,
    overallEventID: '',
    deviceidentifier: '',
    partIndex: 0,
    eventLogo: 'images/VisibbyLight_S.png',
    arrow_stamp: '../images/enjoy/to_stamp-R.png',
    arrow_stamp_L: '../images/enjoy/to_stamp-L.png',
    arrow_message: '../images/enjoy/to_message-R.png',
    arrow_message_L: '../images/enjoy/to_message-L.png',
    arrow_quiz: '../images/enjoy/to_quiz-R.png',
    arrow_quiz_L: '../images/enjoy/to_quiz-L.png',
    navigation_color: '#000000',
    useDarkLogos: false,
    subLogo: '',
    mobileTitle: '',
    backgroundStyle: 'background-image: url("../images/Visibby汎用BG.png");',
    additionalstyle: '-webkit-background-size: cover !important; -moz-background-size: cover !important; -o-background-size: cover !important; background-size: cover !important; background-repeat: no-repeat !important; display: flex !important; align-items: center !important; align-content: center !important; justify-content: center !important; flex-wrap: nowrap !important; background-position: center !important; z-index: 0;',
    pageIndex: 0,
    showFooter: true,
    //Parts on off
    stampsEnabled: false,
    quizEnabled: false,
    chirpEnabled: false,
    //STAMPS
    stampPartIndex: -1,   // Changed from 0 to -1 (not found)
    stampPartID: '',
    StampLogo: '',
    currentIconImage: 'icon_hart_pink_256.png',
    currentIconName: 'LikeHeartPink',
    isChargeMode: true,
    currentChargeColor: '#ffffff',
    mobileAccentColor: '#000000',
    clickSignalTime: 0,
    fireworksEnabled: true,
    alwaysShowFireworks: false,
    showFirework: false,
    stampPartData: {},
    //QUIZ
    votePartIndex: -1,    // Changed from 2 to -1 (not found)
    votePartID: '',
    currentVoteData: {},
    isRefreshingData: false,
    showVoteConfirmation: false,
    keyhackval: 0,
    selectedVoteText: '',
    selectedVoteIndex: -1,
    popupBGColor: "#ffdfbf",
    voteQTextAlign: "center",
    //CHIRP
    chirpPartIndex: -1,   // Changed from 1 to -1 (not found)
    chirpPartID: '',
    ChirpLogo: '',
    syncing: false,
    formData: { /* … */ },
    formErrors: { /* … */ },
    formRules: {
      fullName: { required: true },
      message: { required: true },
    },
    cloudError: '',
    cloudSuccess: false,
    showNameInput: false,
    newlineCharacter: "%0A",
    hashtagCharacter: "%23",
    hashtags: "",
    shouldShowConfirm: true,
    confirmSendModal: false,
    chirpAgainTimeoutID: undefined,
    chirpThemeIndex: 0,
    currentTheme: "",
    chirpPartData: {},
    chirpData: {
      "maxCharacters": 30,
      "welcomeMessage": "メッセージを30文字以内で投稿しよう!<br>Post your message within 30 characters!",
      "welcomeMessage_JP": "メッセージを投稿しよう！",
      "welcomeMessage_EN": "Post your message!",
      "rulesMessage": [
        "●NGワード設定に牴触する表現は投稿できません",
        "Expressions that violate the NG word settings cannot be posted."
      ],
      "dailyTheme": false,
      "rotateTheme": false,
      "defaultTheme": "",
      "sendAgainMessage": "メッセージ入力へ戻る\nSend Another Message",
      "autoChirpAgainTimeout": true
    },
    maxCharacters: 100,
    characterCount: 0,
    exceededLimit: false,
    showCharacterCount: false,
    internalCharCheck: true,
    blockNGWords: true,
    autoChirpAgainTimeout: false,
    downloadPresentURL: '',
    downloadPresentURLName: '',
    downloadType: 'image',
    isChirpagainPressed: false,
    isDownloadPressed: false
    //thankYouMessage: "Thank you!",
    //downloadInstructions: "\"The MOON\"来場記念\n特別画像をダウンロードしよう"
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  computed: {
    // Returns array of visible page DOM indices in order [0,1,2] for existing parts
    visiblePageIndices() {
      const indices = [];
      if (this.stampPartIndex !== -1) indices.push(0);   // stamp
      if (this.chirpPartIndex !== -1) indices.push(1);   // chirp
      if (this.votePartIndex !== -1) indices.push(2);    // quiz
      return indices;
    },

    cleanQuestionText() {
      const text = this.currentVoteData.mobile_text && this.currentVoteData.mobile_text.trim() !== '' ? this.currentVoteData.mobile_text : this.currentVoteData.text;
      return text.replace(/^[\s\u3000]+|[\s\u3000]+$/g, '');
    },

    totalPages() {
      return this.visiblePageIndices.length;
    },

    // DOM index (0,1,2) of the first active/visible page, used to mark the initial carousel-item as "active"
    firstVisibleDomIndex() {
      return this.visiblePageIndices.length > 0 ? this.visiblePageIndices[0] : -1;
    },

    // Maps logical index (0..totalPages-1) to actual DOM index (0,1,2)
    domIndexForLogicalIndex() {
      return (index) => this.visiblePageIndices[index];
    },

    currentPrevArrow() {
      if (this.pageIndex <= 0) return this.arrow_stamp; // hidden when not shown

      const prevLogical = this.pageIndex - 1;
      const prevDomIndex = this.visiblePageIndices[prevLogical];
      const currentDomIndex = this.visiblePageIndices[this.pageIndex];

      return this.getArrowImage(currentDomIndex, prevDomIndex);
    },

    currentNextArrow() {
      if (this.pageIndex >= this.totalPages - 1) return this.arrow_quiz; // hidden when not shown

      const currentDomIndex = this.visiblePageIndices[this.pageIndex];
      const nextLogical = this.pageIndex + 1;
      const nextDomIndex = this.visiblePageIndices[nextLogical];

      return this.getArrowImage(currentDomIndex, nextDomIndex);
    },

    downloadFileName() {
      // Extract just the filename from the URL path
      if (!this.downloadPresentURL) return '';
      return this.downloadPresentURL.substring(this.downloadPresentURL.lastIndexOf('/') + 1);
    },
    questionBoderStyle: function () {
      return {
        backgroundColor: this.currentVoteData.bgcolor || '#FFFFFF', // Use bgcolor for fill, default white
        borderColor: this.currentVoteData.color || '#000000' // Use color for frame, default black
      };
    },
    questionBoxStyle: function () {
      // Based on your last working configuration:
      // 'color' from DB is for the FILL/background color
      // 'bgcolor' from DB is for the FRAME/border color
      let effectiveFrameColor = this.currentVoteData.color || '#000000'; // Default frame color
      return {
        backgroundColor: this.currentVoteData.bgcolor || '#FFFFFF',   // Fill color
        //borderColor: effectiveFrameColor,    // Border color
        //color: this.currentVoteData.textcolor || effectiveFrameColor, // Text color
        //borderStyle: 'solid', // Ensure a solid border style
        //borderWidth: '3px'    // Adjust this value for desired border thickness (e.g., '5px', '10px')
      };
    },
    currentFullStampData: function () {
      return this.eventData.parts[this.stampPartIndex];
    },
    currentFullVoteData: function () {
      return this.eventData.parts[this.votePartIndex];
    },
    currentFullChirpData: function () {
      return this.eventData.parts[this.chirpPartIndex];
    },
    arrowFilterStyle() {
      const color = this.navigation_color;
      if (!color) return {};
      return {
        filter: `drop-shadow(0 0 1px ${color})`
      };
    },
    arrowMaskStyle() {
      return (arrowUrl) => {
        const color = this.navigation_color;
        if (!color || !arrowUrl) return {};

        return {
          'background-color': color,
          '-webkit-mask-image': `url(${arrowUrl})`,
          'mask-image': `url(${arrowUrl})`
        };
      };
    },
    voteIsLive: function () {
      if (this.eventData.parts[this.votePartIndex] && this.eventData.parts[this.votePartIndex].isLive === true
        && this.eventData.parts[this.votePartIndex].questions && this.eventData.parts[this.votePartIndex].questions.length > 0) {
        return this.eventData.parts[this.votePartIndex].questions.some(element => element.isLive === true);
      }
      return false;
    }
  },
  beforeMount: function () {
    //…
  },
  mounted: async function () {
    if (!this.eventData) {
      window.location.href = "/linkexpired";
      return;
    }
    const urlParams = new URLSearchParams(window.location.search);
    this.overallEventID = urlParams.get('eventID');
    this.eventID = this.eventData.id;
    this.eventIsLive = this.eventData.isLive;
    this.setBGStyle(false);
    this.setImages();

    this.deviceidentifier = this.eventData.deviceidentifier;

    // Process parts to set indices
    for (const part of this.eventData.parts) {
      if ((part.partType === 'like' || part.partType === 'stamp') && part.isActive !== false) {
        this.stampPartIndex = part.partIndex;
        this.stampPartID = part.id;
        this.StampLogo = part.logoImage;
        this.stampPartData = part;
        this.stampsEnabled = part.isLive;
        this.currentIconImage = part.icons[0].image;
        this.currentIconName = part.icons[0].name;
        this.currentChargeColor = (part.eventPartOptions.chargeColor) ? part.eventPartOptions.chargeColor : '#ffffff';
        this.mobileAccentColor = (part.eventPartOptions.accentColor) ? part.eventPartOptions.accentColor : '#000000';
      }
      if ((part.partType === 'chirp' || part.partType === 'tweet') && part.isActive !== false) {
        this.chirpPartIndex = part.partIndex;
        this.chirpPartID = part.id;
        this.ChirpLogo = part.logoImage;
        this.chirpPartData = part;
        this.chirpEnabled = part.isLive;
        if (this.chirpPartData.chirpData) {
          this.chirpData = this.chirpPartData.chirpData;
        }
        if (this.chirpPartData.chirpData && this.chirpPartData.chirpData.maxCharacters) {
          if (this.chirpPartData.chirpData.autoChirpAgainTimeout) this.autoChirpAgainTimeout = this.chirpPartData.chirpData.autoChirpAgainTimeout;
          if (this.chirpPartData.chirpData.maxCharacters) this.maxCharacters = this.chirpPartData.chirpData.maxCharacters;
          this.setDownloadInfo();
          if (this.chirpPartData.chirpData.downloadPresentURL) this.downloadPresentURL = this.chirpPartData.chirpData.downloadPresentURL;
          if (this.chirpPartData.chirpData.downloadType) this.downloadType = this.chirpPartData.chirpData.downloadType;
          if (this.chirpPartData.chirpData.showNameInput) this.showNameInput = this.chirpPartData.chirpData.showNameInput;
        }
      }
      if ((part.partType === 'vote' || part.partType === 'qa' || part.partType === 'quiz') && part.isActive !== false) {
        this.questionIndex = 0;
        this.currentVoteData = part.questions[0];
        this.votePartIndex = part.partIndex;
        this.votePartID = part.id;
        this.partIndex = part.partIndex;
        this.quizEnabled = part.isLive; // Set initial state based on whether the part is live
        this.popupBGColor = (part.eventPartOptions.popupBGColor) ? part.eventPartOptions.popupBGColor : '#ffdfbf';
        this.popupTextColor = (part.eventPartOptions.popupTextColor) ? part.eventPartOptions.popupTextColor : '#000000';
        this.pupupSubTextColor = (part.eventPartOptions.pupupSubTextColor) ? part.eventPartOptions.pupupSubTextColor : '#000000';

        if (part.questions.length > 0) {
          this.setCurrentVote(this.questionIndex);
        }
      }
    }

    // Set logical page index (clamped to valid range)
    this.pageIndex = this.initialPage;
    if (this.pageIndex < 0) this.pageIndex = 0;
    if (this.pageIndex >= this.totalPages) this.pageIndex = this.totalPages - 1;

    // Set carousel to actual DOM index
    $('#pageCarousel').carousel(this.visiblePageIndices[this.pageIndex]);

    this.formData.eventid = this.eventID;
    this.formData.partid = this.chirpPartIndex;
    if (this.themeData.length > 0) this.checkTheme();

    io.socket.on(this.eventData.id, (params) => {
      this.showResults = false;
      switch (params.eventType) {
        case 'themechanged':
          this.themeData = params.themeData;
          this.checkTheme();
          break;
        case 'startvote':
        case 'rotatevote':
          this.partIsLive = true;
          this.pleaseWait = false;
          this.setCurrentVote(params.voteid, true);
          this.currentVoteData.isLive = true;
          break;
        case "endquestion":
          this.endQuestion(params.voteid)
          this.setCurrentVote(params.voteid, true);
          break;
        case 'endvote':
          this.partIsLive = false;
          this.setBGStyle(false);
          break;
        case 'startpart':
          const incomingStartPartIndex = Number(params.partindex);

          if (!Number.isNaN(incomingStartPartIndex)) {
            if (incomingStartPartIndex === this.stampPartIndex) {
              this.stampsEnabled = true;
            } else if (incomingStartPartIndex === this.votePartIndex) {
              this.quizEnabled = true;
              this.eventData.parts[this.votePartIndex].isLive = true; // voteIsLive computed relies on this flag
              this.setCurrentVote(this.questionIndex);
            } else if (incomingStartPartIndex === this.chirpPartIndex) {
              this.chirpEnabled = true;
            }
          }
          break;
        case 'endpart':
          const incomingEndPartIndex = Number(params.partIndex);

          if (!Number.isNaN(incomingEndPartIndex)) {
            if (incomingEndPartIndex === this.stampPartIndex) {
              this.stampsEnabled = false;
            } else if (incomingEndPartIndex === this.votePartIndex) {
              this.quizEnabled = false;
              this.eventData.parts[this.votePartIndex].isLive = false;
            } else if (incomingEndPartIndex === this.chirpPartIndex) {
              this.chirpEnabled = false;
            }
          }
          break;
        case 'startevent':
          this.eventIsLive = true;
          break;
        case 'endevent':
          this.eventIsLive = false;
          break;
      }
    });
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    setLogo() {
      if (this.eventData.logoImage) {
        this.eventLogo = this.checkExtension(this.eventData.logoImage);
      }
      if (this.eventData.optionalData && this.eventData.optionalData.mobileLogo) {
        //if the mobileLogo does not end with a file extension, append .webp
        this.eventLogo = this.checkExtension(this.eventData.optionalData.mobileLogo);
      }
      if (this.eventData.subLogoImage) {
        this.subLogo = this.checkExtension(this.eventData.subLogoImage);
      } else {
        this.subLogo = '';
      }
    },

    checkExtension(fileName) {
      if (!/\.[^/.]+$/.test(fileName)) {
          return `${fileName}.webp`;
        } else {
          return fileName;
        }
    },

    // Get appropriate arrow image for transition between two DOM indices
    getArrowImage(fromIndex, toIndex) {
      // Determine target page based on toIndex
      let targetPage;
      if (toIndex === 0) targetPage = 'stamp';
      else if (toIndex === 1) targetPage = 'message';
      else if (toIndex === 2) targetPage = 'quiz';

      // Determine if we're going left or right
      const isGoingLeft = fromIndex > toIndex;

      if (targetPage === 'stamp') {
        return isGoingLeft ? this.arrow_stamp_L : this.arrow_stamp;
      } else if (targetPage === 'quiz') {
        return isGoingLeft ? this.arrow_quiz_L : this.arrow_quiz;
      } else { // targetPage === 'message'
        return isGoingLeft ? this.arrow_message_L : this.arrow_message;
      }
    },
    setImages() {
      this.setLogo();
      if (this.eventData.optionalData) {
        if (this.eventData.optionalData.useDarkLogos) this.useDarkLogos = this.eventData.optionalData.useDarkLogos;
        if (this.eventData.optionalData.mobileTitle) this.mobileTitle = this.eventData.optionalData.mobileTitle;
        if (this.eventData.optionalData.navigationColor) this.navigation_color = this.eventData.optionalData.navigationColor;
        if (this.eventData.optionalData.arrow_stamp) {
          this.arrow_stamp = this.eventData.optionalData.arrow_stamp;
        }
        if (this.eventData.optionalData.arrow_message) {
          this.arrow_message = this.eventData.optionalData.arrow_message;
        }
        if (this.eventData.optionalData.arrow_message_L) {
          this.arrow_message_L = this.eventData.optionalData.arrow_message_L;
        }
        if (this.eventData.optionalData.arrow_quiz) {
          this.arrow_quiz = this.eventData.optionalData.arrow_quiz;
        }
      }
    },
    setBGStyle(isPart) {
      // A mobileBackground image in optionalData takes priority over everything else...
      if (this.eventData.optionalData && this.eventData.optionalData.mobileBackground && this.eventData.optionalData.mobileBackground !== '') {
        this.backgroundStyle = 'background-image: url(\'' + this.checkExtension(this.eventData.optionalData.mobileBackground) + '\') !important; ' + this.additionalstyle;
        return;
      }

      //New processing will begin with a check for a background color inside optionalData. If it exists, we will use that as the background color. If not, continue with the existing logic...
      if (this.eventData.optionalData && this.eventData.optionalData.backgroundColor && this.eventData.optionalData.backgroundColor !== '') {
        this.backgroundStyle = this.additionalstyle + ' background-color: ' + this.eventData.optionalData.backgroundColor + ' !important;';
        return;
      }

      var bgImage = '../images/Visibby汎用BG.png';
      var bgIsColor = false;
      var brightness = 1;

      if (this.eventData.BGImage && this.eventData.BGImage !== '') {
        bgIsColor = this.eventData.BGImage.startsWith('#') === true;
        bgImage = this.eventData.BGImage;
      }

      if (this.eventData.optionalData && this.eventData.optionalData.backgroundBrightness != null) {
        brightness = this.eventData.optionalData.backgroundBrightness;
      }

      if (bgIsColor === true) {
        this.backgroundStyle = this.additionalstyle + ' background-color: ' + bgImage.toLowerCase() + ' !important;';
      } else if (brightness !== 1) {
        this.backgroundStyle = this.additionalstyle +
          ' --bg-image: url(\'' + bgImage + '\');' +
          ' --bg-filter: brightness(' + brightness + ');';
      } else {
        this.backgroundStyle = 'background-image: url(\'' + bgImage + '\') !important; ' + this.additionalstyle;
      }
    },
    selectIcon: function (iconImage, iconName) {
      this.currentIconImage = iconImage;
      this.currentIconName = iconName;
    },
    fireworkChance: function () {
      if (this.eventData.parts[this.stampPartIndex].fireworksEnabled) {
        if (this.eventData.parts[this.stampPartIndex].alwaysShowFireworks) {
          this.showFirework = true;
        } else {
          var generatedNumber = Math.floor(Math.random() * 10000);
          if (generatedNumber <= 50) { this.showFirework = true; }
        }
      } else {
        this.showFirework = false;
      }
    },
    confirmSubmit: async function () {
      var containsNGWords = false;
      if (this.formData.message && this.formData.message.length && this.formData.message.length > 0) {
        containsNGWords = await Cloud.checkNg.with({
          originalText: this.formData.message
        });
      }

      var detectedLanguage = await Cloud.detectLanguage.with({
        text: this.formData.message
      });

      // if (containsNGWords.includesNG === false && (detectedLanguage === "en" || detectedLanguage === "ja")) {
      if (containsNGWords.includesNG === false) {
        if (this.shouldShowConfirm) {
          this.confirmSendModal = true;
          this.cloudError = '';
        }
      } else {
        this.cloudError = 'Language Failure';
      }
    },
    submittedForm: async function (response) {
      if (this.blockNGWords && response && response.containsNG) {
        this.cloudError = response.message;
        return;
      }

      // Show the success message.ror
      this.cloudSuccess = true;
      this.confirmSendModal = false;
      if (this.autoChirpAgainTimeout) this.chirpAgainTimeoutID = setTimeout(this.chirpagain, 5000);
    },
    handleError(error) {
      if (error.response && error.response.data && error.response.data.message) {
        this.cloudError = error.response.data.message;
      }
    },
    chirpagain() {
      this.isChirpagainPressed = true;
      if (this.autoChirpAgainTimeout) clearTimeout(this.chirpAgainTimeoutID);
      this.currentTheme = '';
      this.formData = {}; // Clear the form data object
      this.formErrors = {}; // Clear the form errors object
      this.cloudSuccess = false;
      this.confirmSendModal = false;
      this.syncing = false;
      this.cloudError = '';
      this.formData.eventid = this.eventData.id;
      this.formData.partid = this.chirpPartIndex;
      this.formData.themeID = '';
      this.checkTheme();
      this.isDownloadPressed = false;
      this.isChirpagainPressed = false;
    },
    nextPage() {
      this.pageIndex++;
      if (this.pageIndex >= this.totalPages) this.pageIndex = this.totalPages - 1;
      $('#pageCarousel').carousel(this.visiblePageIndices[this.pageIndex]);
    },
    prevPage() {
      this.pageIndex--;
      if (this.pageIndex < 0) this.pageIndex = 0;
      $('#pageCarousel').carousel(this.visiblePageIndices[this.pageIndex]);
    },
    checkTheme() {
      try {
        const today = new Date();
        const todayDateString = today.toLocaleDateString('en-GB'); // Format: "DD/MM/YYYY"

        let selectedRecord = null;

        for (const record of this.themeData) {

          if (record.overrideIsCurrent) {
            selectedRecord = record;
            break; // No need to check further records
          }

          // Parse the startDateTime from the record
          const [datePart] = record.startDateTime.split(' '); // Extract the date part
          if (datePart === todayDateString) {
            selectedRecord = record;
          }
        }

        if (selectedRecord) {
          this.currentTheme = selectedRecord.text;
          this.formData.themeid = selectedRecord.id.toString();
        } else {
          if (this.themeData.defaultTheme && this.themeData.defaultTheme != '') {
            this.currentTheme = this.themeData.defaultTheme;
          } else {
            this.currentTheme = '';
          }
          this.formData.themeid = '';
        }
      } catch (err) {
        this.formData.themeid = '';
        this.currentTheme = '';
      }
    },
    convertUtcToLocalTime(utcString) {
      const utcDate = new Date(utcString);

      // Get the time difference in milliseconds
      const offset = utcDate.getTimezoneOffset() * 60000;

      // Calculate the local time
      const localDate = new Date(utcDate.getTime() - offset);

      return localDate;
    },
    countCharacters() {
      if (!this.internalCharCheck) { return; }

      try {
        const originalMessage = this.formData.message;

        // 1. Calculate character count for display (excluding line breaks)
        const cleanedMessage = originalMessage.replace(/(\r\n|\n|\r)/gm, "");
        this.characterCount = Array.from(cleanedMessage).length;

        // 2. Determine if limit is exceeded
        this.exceededLimit = this.characterCount > this.maxCharacters;

        if (this.exceededLimit) {
          let visibleChars = 0;
          let truncatedMessage = '';
          for (let i = 0; i < originalMessage.length; i++) {
            const char = originalMessage[i];
            if (char !== '\n' && char !== '\r') {
              visibleChars++;
            }
            if (visibleChars > this.maxCharacters) {
              // We have found the character that exceeds the limit, so we don't include it.
              // The loop will break, and truncatedMessage will have the correct content.
              break;
            }
            truncatedMessage += char;
          }
          this.formData.message = truncatedMessage;

          // Recalculate count for display after truncation
          const finalCleanedMessage = this.formData.message.replace(/(\r\n|\n|\r)/gm, "");
          this.characterCount = Array.from(finalCleanedMessage).length;
        }
      } catch (err) {
        console.error(err);
      }
    },
    setDownloadInfo() {
      //downloadPresentURLName
      if (this.chirpPartData.chirpData.downloadPresentURL) {
        this.downloadPresentURL = this.chirpPartData.chirpData.downloadPresentURL;
        this.downloadPresentURLName = this.downloadFileName; // Use the computed property
      }
    },
    downloadFile: async function () {
      try {
        const response = await fetch(`/download-file?eventid=${this.eventID}&fileName=${this.downloadPresentURLName}&fileURL=${this.downloadPresentURL}`);

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`HTTP error ${response.status}: ${errorText}`);
        }

        const contentDisposition = response.headers.get('Content-Disposition');
        const filename = contentDisposition && contentDisposition.indexOf('attachment') !== -1 ? contentDisposition.split('filename=')[1].replace(/['"]/g, '') : this.downloadPresentURLName; // Extract filename

        const reader = response.body.getReader(); // Get a reader for the stream

        const stream = new ReadableStream({
          start(controller) {
            function push() {
              reader.read().then(({ done, value }) => {
                if (done) {
                  controller.close();
                  return;
                }
                controller.enqueue(value); // Enqueue the chunk
                push(); // Read the next chunk
              });
            }
            push();
          },
        });


        const blob = new Response(stream).blob();
        const url = window.URL.createObjectURL(await blob);

        const a = document.createElement('a');
        a.href = url;
        a.setAttribute('download', filename);
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();

      } catch (err) {
        console.error("Error downloading file:", err);
      }
      // try {
      //   await Cloud.downloadFile.with({eventid: this.eventID, fileName: this.downloadPresentURLName, fileURL: this.downloadPresentURL});
      // } catch (err) {
      //   console.error("Error downloading file:", err);
      // }
    },
    async setCurrentVote(voteIndex, fromSocket = false) {
      this.showVoteConfirmation = false;
      //Loops through all votes and deactivates them, then sets the curent vote as active...
      this.pleaseWait = false;
      this.partIsLive = true;
      this.questionIndex = voteIndex;
      for (var p in this.eventData.parts) {
        p.isLive = false;
      }
      // this.currentVoteData = this.eventData.parts[this.votePartIndex];
      this.currentVoteData.isLive = true;
      //Try to get fresh data...
      if (this.isRefreshingData === false) await this._fetchNewQuestionData();

      if (fromSocket === false) {
        for (var timmy = 0; timmy < this.eventData.parts[this.votePartIndex].questions.length; timmy++) {
          if (this.eventData.parts[this.votePartIndex].questions[timmy].isLive === true) {
            this.questionIndex = timmy;
            break;
          }
        }
      }
      this.voteQTextAlign = this.GetvoteQTextAlign(this.questionIndex);
      this.currentVoteData = this.eventData.parts[this.votePartIndex].questions[this.questionIndex];
      this.currentVoteData.voted = false;
      this.currentVoteData.votedIndex = -1;
      this.selectedVoteIndex = -1;
      this.currentVoteData.partindex = this.votePartIndex;
      this.keyhackval = Math.floor(Math.random() * 100) + 1;
    },
    endQuestion(voteIndex) {
      this.eventData.parts[this.votePartIndex].questions[voteIndex].isLive == false;
      this.currentVoteData.isLive = false;
    },
    voteSelected: function (index) {
      this.currentVoteData.votedIndex = index;
      this.selectedVoteIndex = index;
      this.selectedVoteText = this.currentVoteData.votes[index].text;
    },
    voted: function () {
      this.currentVoteData.voted = true;
      this.showVoteConfirmation = true;
      // Auto-hide the confirmation popup after 3 seconds
      setTimeout(() => {
        this.showVoteConfirmation = false;
      }, 10000);
    },
    GetvoteQTextAlign: function (voteIndex) {
      //this.eventData.parts[this.votePartIndex].questions[this.questionIndex].textAlign is either 0, 1, or 2. Set text alignment based on that value...
      if (this.eventData.parts[this.votePartIndex].questions[voteIndex].textAlignment === 1) {
        return 'center';
      } else if (this.eventData.parts[this.votePartIndex].questions[voteIndex].textAlignment === 2) {
        return 'right';
      }
      return 'left';
    },
    _fetchNewQuestionData: async function () {
      this.isRefreshingData = true;
      try {
        const response = await fetch(`getquizdataforpart?partid=${this.currentFullVoteData.id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (data !== null && data.length > 0) {
          this.eventData.parts[this.votePartIndex].questions = data;
        }
        this.isRefreshingData = false;
      } catch (error) {
        this.isRefreshingData = false;
      }
    },
    // Helper functions for color conversion
    hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => {
        return r + r + g + g + b + b;
      });

      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
    rgbToHsv(r, g, b) {
      r /= 255, g /= 255, b /= 255;
      const max = Math.max(r, g, b), min = Math.min(r, g, b);
      let h, s, v = max;

      const d = max - min;
      s = max === 0 ? 0 : d / max;

      if (max === min) {
        h = 0; // achromatic
      } else {
        switch (max) {
          case r: h = (g - b) + d * (g < b ? 6 : 0); break;
          case g: h = (b - r) + d * 2; break;
          case b: h = (r - g) + d * 4; break;
        }
        h /= 6;
      }

      return {
        h: h * 360, // degrees
        s: s,
        v: v
      };
    }
  }
});
